module.exports = __webpack_public_path__ + "e-learning-app/static/img/school5.653deb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-course/img/ne/school5.png
// module id = wwn9
// module chunks = 1